"use client";

import { useRouter } from "next/navigation";
import { useState, useTransition } from "react";
import { toggleSave } from "@/lib/actions/social";

export function SaveButton({
  bookId,
  initialSaved,
  signedIn,
}: {
  bookId: string;
  initialSaved: boolean;
  signedIn: boolean;
}) {
  const router = useRouter();
  const [saved, setSaved] = useState(initialSaved);
  const [pending, start] = useTransition();

  function onClick() {
    if (!signedIn) {
      router.push("/signin?next=" + encodeURIComponent(window.location.pathname));
      return;
    }
    setSaved((s) => !s);
    start(async () => {
      const res = await toggleSave(bookId);
      if ("error" in res) {
        setSaved(initialSaved);
        router.push("/signin");
      } else setSaved(res.saved);
    });
  }

  return (
    <button
      onClick={onClick}
      disabled={pending}
      className="flex h-[44px] flex-1 items-center justify-center gap-1.5 rounded-[12px] border text-[13.5px] font-bold transition-colors disabled:opacity-60"
      style={
        saved
          ? { borderColor: "var(--copper)", background: "rgba(184,111,68,.1)", color: "var(--copper)" }
          : { borderColor: "var(--border)", background: "var(--surface)", color: "var(--ink-3)" }
      }
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill={saved ? "currentColor" : "none"}>
        <path d="M4 2h8v12l-4-3-4 3V2z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
      </svg>
      {saved ? "Saved" : "Save"}
    </button>
  );
}
